$(document).ready(function () {

	/* ---------------------------------------- */
	/* ----- >>> Menu ------------------------- */
	/* ---------------------------------------- */
	
	$('.setMenu').click(function(){
		$('.setMobile').slideToggle('fast').css('display','flex');
		$('header').toggleClass('getOpen');
	});

	/* ---------------------------------------- */
	/* ----- >>> Stick Header ----------------- */
	/* ---------------------------------------- */

	$(function () {
		var setTarget = $('header');
		var setObject = $(window).height() / 100;
		var setSlider = $(window).height();
		var setWindow = $(window);
		var setScroll = setWindow.scrollTop();
		if (setObject != 0 ) {
			setWindow.scroll(function () {
				var setScroll = setWindow.scrollTop();
				if (setScroll > setObject) {
					setTarget.addClass('isSmall')
				} else {
					setTarget.removeClass('isReset');
					setTarget.removeClass('isSmall');
				}
			});
		} else {
			setTarget.addClass('isSmall');
		}
	});

	if ($(window).scrollTop() > 0) {
		$('header').addClass('isReset');
	}


	/* ---------------------------------------- */
	/* ----- >>> Menu ------------------------- */
	/* ---------------------------------------- */

	if ($(window).width() < 640 ) {

		$('.setMobile > ul > li > a[href^="#"]').click( function(e) {
			var setTarget = $(this).attr('href');
			if ($(this).next().hasClass('isExpand')) {
				$('.isExpand').slideUp('fast').removeClass('isExpand');
			} else {
				$('.isExpand').slideUp('fast').removeClass('isExpand');
				$(this).next().slideDown('fast').addClass('isExpand');
			}
			e.preventDefault();
		});

	} else {

		$('nav > ul > li > a[href^="#"]').click( function(e) {
			var setTarget = $(this).attr('href');
			$('nav > ul > li > a').removeClass('isCurrent');
			$('header').removeClass('isOpen');
			$('.setNav').slideUp(100);

			$(setTarget).slideDown(100).addClass('isActive');
			$('header').addClass('isOpen');
			$(this).addClass('isCurrent');
			e.preventDefault();
		});

		$('header').mouseleave(function() {
			$('nav > ul > li > a').removeClass('isCurrent');
			$('header').removeClass('isOpen');
			$('.setNav').slideUp(100);
		});
	}

	/* ---------------------------------------- */
	/* ----- >>> Media Accordion -------------- */
	/* ---------------------------------------- */

	$('dl > dt').on('click', function () {
		if (!$(this).hasClass('isOpen')) {
			$(this).parent().children('dd').slideUp('fast');
			$('dl > dt').removeClass('isOpen');
			$(this).addClass('isOpen');
			$(this).next().slideDown('fast');
		} else {
			$(this).parent().children('dd').slideUp('fast');
			$('dl > dt').removeClass('isOpen');
		}
		return false;
	});
	
	/* ---------------------------------------- */
	/* ----- >>> Tabs ------------------------- */
	/* ---------------------------------------- */

	$('.setTab > ul > li > a').click( function(event) {
		var setT = $(this).parent();
		var setI = $(this).parent().index() + 1;
		$('.setTab > ul > li').removeClass('isCurrent');
		$(setT).addClass('isCurrent');
		$('.setTab > ul:nth-child(2) > li').slideUp('fast');
		$('.setTab > ul:nth-child(2) > li:nth-child('+setI+')').slideDown('fast');
		event.preventDefault();
	})

	$('.setModal .isCLS').click( function() {
		Cookies.set('getModal', 1, { expires: 1 });
		$('.setModal').fadeOut(100);
	});
	
	/* ---------------------------------------- */
	/* ----- >>> Calendar---------------------- */
	/* ---------------------------------------- */

	/*var setCalendar = new Swiper('.setCalendar', {
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		slidesPerGroup: 5,
		slidesPerView: 5
	});*/

	$('.setCalendar > div > div > div').not('.isDisabled').click( function() {
		var getData = $(this).data('date');
		$('.setCalendar div').removeClass('isCurrent');
		$(this).addClass('isCurrent');
		$('#isDate').val(getData);
		console.log(getData);
	})

	$('.isAppointment a[href*="#getNext"]').click( function(e) {
		$('.isAppointment .isS02').slideDown('fast');
		$('.isAppointment .isS01').slideUp('fast');
		e.preventDefault();
	})

	$('.isAppointment a[href*="#getBack"]').click( function(e) {
		$('.isAppointment .isS01').slideDown('fast');
		$('.isAppointment .isS02').slideUp('fast');
		e.preventDefault();
	})

	$('a[href*="#Close"]').click( function(e) {
		$('.setOutput').fadeOut('fast');
		e.preventDefault();
	})

	/* ---------------------------------------- */
	/* ----- >>> Slide Content ---------------- */
	/* ---------------------------------------- */

	$('.setSwiper').each( function(ID,value) {
		var getMin	= $(this).data('min');
		var getMax	= $(this).data('max');
		var getGap	= $(this).data('gap');
		var getLop	= $(this).data('loop');
		var setMov	= $(this).data('slide');

			  		$(this).addClass('isS000'+ID);
		$('.setPrev', this).addClass('isP000'+ID);
		$('.setNext', this).addClass('isN000'+ID);
		$('.setDots', this).addClass('isD000'+ID);

		var setSwiper = new Swiper($('.isS000'+ID), {
			watchSlidesVisibility	: true,
			watchSlidesProgress		: true,
			slideToClickedSlide		: true,
			centeredSlidesBounds	: false,
			watchOverflow			: false,
			allowTouchMove			: true,
			centeredSlides 			: false,
			slidesPerGroup			: getMin,
			slidesPerView			: getMin,
			spaceBetween			: 16,
			wrapperClass			: 'setItems',
			slideClass				: 'setItem',
			speed					: 750,
			loop					: getLop,
			autoplay				: setMov,
			navigation				  : {
				prevEl				: '.isP000'+ID,
				nextEl				: '.isN000'+ID,
			},
			pagination				: {
				bulletActiveClass	: 'isActive',
				el					: '.isD000'+ID,
				bulletClass			: 'setDot',
				clickable			: true
			},
			slidesPerColumnFill		: 'row',
			breakpoints				: {
				640: {
					slidesPerGroup	: getMin,
					slidesPerView	: getMin,
					spaceBetween	: 16,
				},
				1024: {
					slidesPerGroup	: getMax,
					slidesPerView	: getMax,
					spaceBetween	: getGap,
				}
			}
		});
	});
	
	/*var setSlider = new Swiper('.setSlider', {
		loop			: true,
		speed			: 1500,
		effect			: 'fade',
		slidesPerView	: 1,
		navigation: {
			prevEl: '.setPrev',
			nextEl: '.setNext',
		},
		/*autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		}
	}); */

	
	var setTHB = new Swiper('.setThumbnails', {
		watchSlidesVisibility	: true,
		watchSlidesProgress		: true,
		slidesPerView			: 3,
		spaceBetween			: 12,
		wrapperClass			: 'setItems',
		slideClass				: 'setItem',
		breakpoints: {
			640: {
				spaceBetween	: 12,
			},
			768: {
				spaceBetween	: 32,
			},
			1024: {
				spaceBetween	: 48,
			},
		}
	});

	var setGAL = new Swiper('.setGallery', {
		slidesPerView			: 1,
		wrapperClass			: 'setItems',
		slideClass				: 'setItem',
		thumbs: {
			swiper 				: setTHB
		},
		navigation: {
			prevEl 				: '.setPrev',
			nextEl 				: '.setNext',
		}
	});

	/* ---------------------------------------- */
	/* ----- >>> Filters ---------------------- */
	/* ---------------------------------------- */

	$('.setFilters > h5').click( function(e) {
		$(this).parent().toggleClass('isOpen');
		$(this).next().slideToggle('fast');
		e.preventDefault();
	})


	/* ---------------------------------------- */
	/* ----- >>> Cart Quantity ---------------- */
	/* ---------------------------------------- */

	$('#getCart').getUpdate({
		getItem 	: '.setItem',
		getQtty		: '.setQty',
		getSbtl		: '.setMath',
		getTotal	: '.setTotal',
		getItems 	: '.setCount'
	});
	
	$('.setLess').click( function() {
		var setInput = $(this).parent().find('.setQtty')
		var setLimit = setInput.attr('min');
		var setValue = +setInput.val() - 1
		if ( setValue >= setLimit ) {
			setInput.val( setValue ).blur();
		}
		return false;
	})

	$('.setMore').click( function() {
		var setInput = $(this).parent().find('.setQtty')
		var setLimit = setInput.attr('max');
		var setValue = +setInput.val() + 1
		if ( setValue <= setLimit ) {
			setInput.val( setValue ).blur();
		}
		return false;
	})
	

	/* ---------------------------------------- */
	/* ----- >>> Variants --------------------- */
	/* ---------------------------------------- */

	$('.setSelect select').on('change', function() {     

		console.clear();

		var setVRT = $('.setSelect').length;
		var setVTS = '';
		for (var i = 0; i < setVRT; i++) {
			var setVTO = $('.setSelect select#setID'+i).val();
			setVTS = setVTS+' / '+setVTO
		}

		setVTS = setVTS.substring(3);

		setUpdate($('#setVariants option:contains('+setVTS+')').val(), $('#setVariants option:contains('+setVTS+')').data('stock') );

		/* ---------------------------------------- */

		$('#setVariants option').removeAttr('selected');
		var setTRG = $('#setVariants option:contains(/ '+setVTS+' /)')


		if (!setTRG.is(':disabled')) {
			setTRG.attr('selected', true);
		}

	});

	function setUpdate(setVar, setStock) {
		$.each(getJSON.variants, function(i){
			if (setVar == getJSON.variants[i].id) {
				var setSTK = setStock;
				var setPRC = getJSON.variants[i].price;
				var setAVL = getJSON.variants[i].available;
				var setCMP = getJSON.variants[i].compare_at_price;
				

				// console.log(getJSON.variants[i])

				if (setCMP != null ) {
					$('.setPRC').html(getMoney(setPRC)+' <del>'+getMoney(setCMP)+'</del>');
				} else {
					$('.setPRC').html(getMoney(setPRC));
				}

				if (setAVL == true) {
					if ( setSTK == 0) {
					$	('.setSubmit').val('Agotado').attr('disabled', true).hide();
						$('.setPreoder').show();
						$('.setNote').fadeIn('fast');
						setMax = 100;
					} else {
						$('.setSubmit').val('Agregar al Carrito').attr('disabled', false).show();
						$('.setPreoder').hide();
						$('.setNote').fadeOut('fast');
						setMax = setSTK;
					}
					$('.setLess').attr('disabled', false);
					$('.setMore').attr('disabled', false);
					$('.setQtty').attr('max', setMax);
					$('.setQtty').val('1');
				}  else {
					$('.setPreoder').hide();
					$('.setSubmit').val('Agotado').attr('disabled', true).show();
					$('.setLess').attr('disabled', true);
					$('.setMore').attr('disabled', true);
					$('.setNote').fadeOut('fast');
					$('.setQtty').val('0');
				}

				var setIMG = getJSON.variants[i].featured_image ? getJSON.variants[i].featured_image.id : null;
				if (setIMG != null)	{
					setGAL.slideTo( $('#'+setIMG).index(),0,false );
				}
			}
		})
	}	

	function getMoney (setVar) {
		return '$'+setVar.toString().slice(0, -2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
	}
	
	/* ---------------------------------------- */
	/* ----- >>> Media Accordion -------------- */
	/* ---------------------------------------- */

	$('.getEdit').click( function(event) {
		var setTarget = $(this).attr('href');
		$('.isOpen').slideToggle(0).removeClass('isOpen')
		$(setTarget).slideToggle(0).addClass('isOpen');
		event.preventDefault();
	})

	$('.getClose').click( function(event) {
		$('.isOpen').slideToggle(0).removeClass('isOpen')
		$('#isADS00').slideToggle(0).addClass('isOpen');
		event.preventDefault();
	})

	$('.getRemove').click( function(event) {
		var setTarget = $(this).attr('href');
		$(setTarget).trigger('click');
		event.preventDefault();
	})

	/* ---------------------------------------- */
	/* ----- >>> Mailto Links ----------------- */
	/* ---------------------------------------- */

	var siteDomain = '@issefinejewelery.com';
	$('a[href*="mailto"]').not('.isExclude').not(':contains("@")').each(function () {
		$(this).attr('href', function (index, value) {
			return (value + siteDomain);
		});
		$(this).not('.exclude').text(function (index, text) {
			return (text + siteDomain);
		});
	});

	/* ---------------------------------------- */
	/* ----- >>> Sticky Footer ---------------- */
	/* ---------------------------------------- */

	var wHeight = $(window).height();
	var dHeight = $(document).height();
	if (wHeight >= dHeight) {
		$('footer').css('position','fixed').css('bottom',0);
	}

	/* ---------------------------------------- */
	/* ----- >>> Set Uniform Js --------------- */
	/* ---------------------------------------- */

	// $('select, input[type=checkbox], input[type=radio], input[type=file]').uniform();

});